import { Grid } from '@mui/material';
import { StatsProps } from './MatchPlayerStats';

export const MatchTeamsStats = ({ matchStats, matchId }: StatsProps) => {
  if (!matchStats) return null;

  const match = matchStats.find((match) => match?.MatchFeedId === matchId);
  if (!match) return null;

  const homeTeamStats = match.MatchStats.find(
    (stat: any) => stat.TeamFeedId === match.HomeTeamFeedId
  );
  const awayTeamStats = match.MatchStats.find(
    (stat: any) => stat.TeamFeedId === match.AwayTeamFeedId
  );
  if (!homeTeamStats || !awayTeamStats) return null;

  return (
    <Grid container sx={{ textAlign: 'left' }}>
      <Grid item xs={6}>
        Hits: {homeTeamStats.Hits}
        <br />
        Shots: {homeTeamStats.ShotsOnGoal}
        <br />
        PPG: {homeTeamStats.Goals}
        <br />
        SHG: {homeTeamStats.ShotsOnGoal}
        <br />
      </Grid>
      <Grid item xs={6} textAlign='right'>
        {awayTeamStats.Hits}: Hits
        <br />
        {awayTeamStats.ShotsOnGoal} :Shots
        <br />
        {awayTeamStats.Goals} :PPG
        <br />
        {awayTeamStats.ShotsOnGoal} :SHG
        <br />
      </Grid>
    </Grid>
  );
};
